/**
 * @file badge.component.tsx
 * @description Компонент обертка для работы @consta/uikit/Badge.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [@consta/uikit/Badge]
 */

import { Badge as ConstaBadge } from '@consta/uikit/Badge';

export const Badge = (props: React.ComponentProps<typeof ConstaBadge>) => {
    return <ConstaBadge {...props} />;
};
